// PACKAGES
import { firestore } from "./config";
import { resolveDisplayPrices } from "@learnzapp/core/pricing";
import { symbolFor } from "../constant/currencyUtils";

async function GET_ACCESS_CODE_DETAILS(code) {
  try {
    const result = await firestore()
      .collection("stripe")
      .doc("access")
      .collection("codes")
      .doc(code)
      .get();
    if (result.exists) {
      return { status: true, data: result?.data(), error: null };
    } else {
      return {
        status: false,
        data: null,
        error:
          "This access code does not exists. Please contact support to resolve this issue",
      };
    }
  } catch (error) {
    return { status: false, data: null, error: error.message };
  }
}

async function UPDATE_ACCESS_CODE_REDEEM(code, email) {
  try {
    await firestore()
      .collection("stripe")
      .doc("access")
      .collection("codes")
      .doc(code)
      .update({
        is_redeemed: true,
        redeemed_by: email,
      });
    return { status: true, data: null, error: null };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function GET_PRODUCT_PRICES(productId, currencyData) {
  try {
    // One read: the Stripe extension's mirror of the product's prices. It carries
    // which prices are ACTIVE, the base USD amount, interval, nickname — and the
    // price's Stripe `metadata`, where `localized_amounts` (a JSON map written by
    // `npm run prices:sync` from the price's currency_options) lives. So the
    // per-currency amounts arrive by the same webhook as everything else; there is
    // no table in the repo and no second document. See docs/STRIPE_PRICES_GUIDE.md.
    //
    // Resolution is in @learnzapp/core/pricing and is all-or-nothing per product:
    // every active price localizes to the visitor's currency, or every price
    // shows its base amount (which is also what Stripe charges then). Rows
    // without a unit amount are dropped, never shown as $0.
    const result = await firestore()
      .collection("products")
      .doc(productId)
      .collection("prices")
      .orderBy("unit_amount")
      .get();
    const mirror = result.docs.map((doc) => ({ ...doc.data(), priceId: doc.id }));
    const resolved = resolveDisplayPrices(mirror, currencyData?.currencyCode);
    if (resolved.stalePriceIds.length || resolved.missingPriceIds.length) {
      // Not an error for the visitor (they see USD, Stripe charges USD) but the
      // catalog needs a `prices:sync`.
      console.warn("[GET_PRODUCT_PRICES] localized amounts withheld", {
        productId,
        currency: currencyData?.currencyCode,
        stale: resolved.stalePriceIds,
        missing: resolved.missingPriceIds,
      });
    }
    const newData = resolved.rows.map(({ price, unitAmount, currencyCode }) => ({
      ...price,
      unit_amount: unitAmount,
      // Keep the Stripe-shaped `currency` in step with the amount so analytics
      // (purchase_intent, winback) never log a rupee amount as USD.
      currency: currencyCode.toLowerCase(),
      currencyCode,
      currencySymbolHtml: symbolFor(currencyCode),
    }));
    return { status: true, data: newData, error: null };
  } catch (error) {
    return { status: false, error: error.message };
  }
}
export {
  GET_ACCESS_CODE_DETAILS,
  UPDATE_ACCESS_CODE_REDEEM,
  GET_PRODUCT_PRICES,
};
